<div class="workspace-drawer">
  @for (workspace of workspaces(); track workspace.id) {
  <div
    class="sidebar-button"
    [ngClass]="{
      'sidebar-button--active': selectedWorkSpace()?.id === workspace?.id
    }"
    (click)="onClick(workspace)">
    {{ workspace.shortVersion }}
  </div>
  }
</div>
